import { render, staticRenderFns } from "./apicredentialdetail.vue?vue&type=template&id=36b0fb12&scoped=true"
import script from "./apicredentialdetail.vue?vue&type=script&lang=js"
export * from "./apicredentialdetail.vue?vue&type=script&lang=js"
import style0 from "./apicredentialdetail.vue?vue&type=style&index=0&id=36b0fb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0fb12",
  null
  
)

export default component.exports